<template>
    <sub-page :fullPage="true">
        <div class="excise-wrap">

            <div :span="24" class="excise-left">
                <el-form class="rank-query" :model="formSearch" :inline="true" size="mini">
                        <select-multiple :nameArrays="selectNames"
                                         @imageTypesVal="imageTypesVal">
                        </select-multiple>
                        <el-form-item>
                            <el-button type="primary" @click="query" round>{{$t('c.query')}}</el-button>
                        </el-form-item>
                    </el-form>
                <data-tables class="form-table"
                             ref="recordTable"
                             :data="exciseTable"
                             :table-props="tableProps"
                             :current-page.sync="currentPage"
                             :page-size="20"
                             :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                             header-align="center"
                             v-loading="tableLoading"
                >
                    <el-table-column type="index" width="40" align="center"></el-table-column>
                    <el-table-column property="type" label="图像类型" align="center" show-overflow-tooltip
                                     sortable>
                        <template slot-scope="scope">
                            <span class="type-bg" :class="typeBg(scope.row.type)">{{scope.row.typeName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column property="formName" :label="$t('stu.practiceMode')" align="center" show-overflow-tooltip
                                     sortable>
                    </el-table-column>
                    <el-table-column property="total" :label="$t('stu.images')" align="center" show-overflow-tooltip
                                     sortable>

                    </el-table-column>
                    <el-table-column property="correct" :label="$t('count.rightNum')" align="center" show-overflow-tooltip
                                     sortable>
                        <!--<template slot-scope="scope">-->
                        <!--<span style="color: #ffb822;font-size: 16px">{{scope.row.totalSeconds}}</span>-->
                        <!--</template>-->
                    </el-table-column>
                    <el-table-column property="wrong" :label="$t('count.wrongNum')" min-width="120" align="center" show-overflow-tooltip
                                     sortable>

                    </el-table-column>
                    <el-table-column property="overTime" :label="$t('stu.timeoutNum')" min-width="120" align="center" show-overflow-tooltip
                                     sortable>

                    </el-table-column>
                    <el-table-column property="startTime" :label="$t('c.startTime')" min-width="120" align="center" show-overflow-tooltip
                                     sortable>

                    </el-table-column>
                    <el-table-column property="submitTime" :label="$t('c.endTime')" min-width="120" align="center" show-overflow-tooltip
                                     sortable>

                    </el-table-column>

                </data-tables>
            </div>
        </div>
    </sub-page>
</template>

<script>
    import api from '@/api';
    import SubPage from '@/components/Subpage.vue';
    import SelectMultiple from '@/components/Selectmultiple';

    var echarts = require('echarts');
    export default {
        props: {
            'userID': String,
            'searchData': String
        },
        data() {
            return {
                // 表格信息开始
                exciseTable: [],
                tableProps: {
                    border: true,
                    stripe: true,
                    rowKey: row => row.id,
                    height: "auto"
                },
                currentPage: 1,
                formSearch: {
                    types: [],
                    startTime: '',
                    endTime: '',
                    limit: -1
                },
                // 表格信息结束
                selectNames: [
                    {
                        key: "imageTypes",
                        value: [0],
                    }],
                exciseMonthShow: true,
                exciseTypeShow: true,
                avatar: '',
                userName: '',
                accountNo: '',
                tableLoading: true,
            }
        },
        created() {
            this.$nextTick(() => {
                this.query();
            })

        },
        computed: {
        },
        methods: {
            query() {
                this.currentPage = 1;
                let searchData = JSON.parse(this.searchData)
                let queryData = {
                    type: this.formSearch.types,
                    startTime: searchData.startTime,
                    endTime: searchData.endTime,
                };
                if (queryData['type'] && queryData['type'][0] == 0) {
                    delete queryData['type'];
                }
                api.getImageExciseDetail(this.userID, queryData).then((res) => {
                    if (res.package) {
                        this.exciseTable = res.package;
                    }
                    this.tableLoading = false;
                })

            },
            imageTypesVal(data) {
                this.formSearch.types = data;
            },

            //当前日期
            currentDate(num) {
                let myDate = new Date();
                if (num > 0) {
                    myDate = new Date(myDate - 1000 * 60 * 60 * 24 * 30 * num)
                }
                let nowY = myDate.getFullYear();
                let nowM = myDate.getMonth() + 1;
                let nowD = myDate.getDate();
                let enddate = nowY + "-" + (nowM < 10 ? "0" + nowM : nowM) + "-" + (nowD < 10 ? "0" + nowD : nowD);//当前日期
                return enddate
            },
            typeBg(type){
                let typeColor=''
                switch (type){
                    case 3:
                        typeColor='ct';
                        break;
                    case 4:
                        typeColor='dr';
                        break;
                    default:
                        typeColor=''
                }
                return typeColor
            },
           getHMSTime (second_time) {
                var time = second_time + "秒";
                if( second_time > 60){
                    var second = parseInt(second_time) % 60;
                    var min = parseInt(second_time / 60);
                    time = min + "分钟" + second + "秒";
                    if( min > 60 ){
                        min = parseInt(second_time / 60) % 60;
                        var hour = parseInt( parseInt(second_time / 60) /60 );
                        time = hour + "小时" + min + "分钟" + second + "秒";
                        if( hour > 24 ){
                            hour = parseInt( parseInt(second_time / 60) /60 ) % 24;
                            var day = parseInt( parseInt( parseInt(second_time / 60) /60 ) / 24 );
                            time = day + "天" + hour + "小时" + min + "分钟" + second + "秒";
                        }
                    }
                }
                return time
            },
        },
        watch: {},
        components: {
            SubPage,
            SelectMultiple,
        }

    }
</script>

<style scoped lang="scss">
    .excise-wrap {
        height: 100%;
        display: flex;
    }

    .excise-left, .excise-right {
        height: 100%;
        border: 1px solid #ebebed;

    }

    .excise-left {
        width: 100%;
        /*margin-right: 20px;*/
        padding: 10px;
    }


    .form-table {
        display: flex;
        flex: 1;
        flex-direction: column;
        height: 95%;
    }
    .type-bg{
        display: inline-block;
        width: 80px;
        border-radius: 1px;
        color: #fff;
        &.theory{
            background-color: #6a7881;
        }
        &.ct{
            background-color: #0396a6;
        }
        &.dr{
            background-color: #f4516c;
        }
    }
</style>
